import { render, staticRenderFns } from "./MhRouterViewWrapper.vue?vue&type=template&id=404b588b&"
import script from "./MhRouterViewWrapper.vue?vue&type=script&lang=js&"
export * from "./MhRouterViewWrapper.vue?vue&type=script&lang=js&"
import style0 from "./MhRouterViewWrapper.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../GbR/10__Projekte/2020-05-28__ROTORBOOKS/03  Website/wordpress/wp-content/themes/wp-kickstart-v3-theme/vue-cli-dev/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports